import { JSON_REDIRECT_CONTENT_TYPE } from "@pdfking/constants/settings"
import { PARSABLE_COMMENT } from "@pdfking/constants/settings"
import { first, scan } from "@pdfking/rfunc"
import { IsString, JSONDecode } from "@pdfking/tfunc"
import {
  ResponseContentType,
  ResponseFileName,
  ResponseHeader,
} from "@pdfking/tfunc"
import { FETCH } from "@pdfking/translations/enum/trackers"
import create_blob from "@pdfking/workflow/utils/create_blob"
import fire_event from "@pdfking/workflow/utils/fire_event"
import { startswith } from "@pdfking/workflow/utils/strings"
import track_promise from "@pdfking/workflow/utils/track_promise"
import { url_parse } from "@pdfking/workflow/utils/urlutilities"
import uuid from "@pdfking/workflow/utils/uuid"
import download_url from "src/files/actions/download_url"

import el from "../dom/element"
import selector from "../dom/selector"
import state from "../state/main"
import navigator from "../state/navigator"
import scroll_to from "../utils/scroll_to"
import change_window_location from "./change_window_location"
import check_url_is_ajax from "./check_url_is_ajax"
function data_to_form_data(data) {
  if (IsString(data)) {
    const params = new URLSearchParams(data)
    const temp = new FormData()

    for (const [k, v] of params.entries()) {
      temp.append(k, v)
    }

    return temp
  }

  return data
}

const read = (url, data) =>
  track_promise(
    emit =>
      fetch(
        url,
        data
          ? {
              method: "post",
              body: data_to_form_data(data),
            }
          : null
      ),
    emit => emit({ name: FETCH, done: 0, total: 1 }),
    emit => emit({ name: FETCH, done: 1, total: 1 })
  )

export default (
  url,
  {
    data = null,
    change_location = true,
    scroll_control = true,
    oncomplete = () => {},
  }
) => {
  if (!state.IS_SUBMITTED) {
    let input = first(selector(":focus"))

    console.info("start_request: ", { url, data })

    state.IS_SUBMITTED = true
    state.LAST_FOCUS = input ? input.id : null
    state.AJAX_COUNTER += 1
    state.request_id = uuid()

    const parsed = url_parse(url)

    read(parsed.href, data).then(async r => {
      const text = await r.clone().text()

      const path = url_parse(ResponseHeader(r, "X-Real-Path") || r.url)
      const mode = ResponseHeader(r, "X-Change-Location")
      const cttp = ResponseContentType(r)

      const is_parsable = startswith(text, PARSABLE_COMMENT)

      const is_redirect = cttp == JSON_REDIRECT_CONTENT_TYPE

      state.IS_SUBMITTED = false

      if (is_redirect) {
        const url = JSONDecode(text).location
        return change_window_location(url)
      }

      if (!check_url_is_ajax(path)) {
        // the ajax request ended up doing an external redirect, should not happen
        window.location = path.href
        return
      }

      if (!is_parsable) {
        if (cttp == "text/html") {
          document.open(cttp)
          document.write(text)
          document.close()

          // after writing a new document all the state is fucked up
          // it is a much cleaner solution to just re-perform the request when pressing back
          window.onpopstate = () => (window.location = window.location.href)

          navigator.push_state(url)

          return
        }

        return download_url(
          create_blob(await r.bytes(), cttp),
          ResponseFileName(r)
        )
      }

      fire_event(document, "before_json", {
        counter: state.AJAX_COUNTER,
      })

      if (change_location && mode !== "prevent") {
        console.log("current url: " + window.location.href)

        if (window.location.href != path.href) {
          if (mode == "replace") {
            navigator.replace_state(path.href)
          } else {
            navigator.push_state(path.href)
          }
        }
      }

      const scripts = []

      scan(
        el => {
          if (el.tagName == "SCRIPT") {
            scripts.push(el.innerHTML)
          } else {
            const target = document.getElementById(
              el.getAttribute("data-block-id")
            )
            const attr = el.getAttribute("data-block-replace")

            if (attr) {
              target.setAttribute(attr, el.getAttribute(attr))
            } else if (target) {
              target.replaceWith(el)
            } else {
              console.info(
                `element with block name ${el.getAttribute("data-block-id")} not found`
              )
            }
          }
        },
        selector("[data-block-id]", el("html", {}, text))
      )

      scan(eval, scripts)

      if (
        scroll_control &&
        ResponseHeader(r, "X-Scroll-Control") !== "prevent"
      ) {
        setTimeout(() => scroll_to(path.hash || parsed.hash || null), 10) // the timeout is needed to prevent the scrolling to trigger before the content is addee
      }

      if (state.LAST_FOCUS) {
        let input = first(selector("#" + state.LAST_FOCUS))
        if (input) input.focus()
      }

      fire_event(document, "after_json", {
        counter: state.AJAX_COUNTER,
        initial: state.AJAX_COUNTER == 0,
      })

      oncomplete(r)
    })
  }
}
